(function () {
  var root = document.querySelector(".eu-withdrawal-form");
  if (!root) return;
  var form = root.querySelector(".ewf__form");
  var endpoint = root.getAttribute("data-withdrawal-endpoint");
  var startedAt = Date.now(); // bot signal: a human spends real time on the two-step form
  var fields = ["name", "email", "orderRef", "countryCode", "items"];
  var labels = { name: "Name", email: "Email", orderRef: "Order", countryCode: "Country", items: "Item(s)" };
  var step1 = form.querySelector('[data-step="1"]'), step2 = form.querySelector('[data-step="2"]'), done = form.querySelector(".ewf__done");
  function val(n) { return (form.elements[n].value || "").trim(); }
  function setErr(n, m) { var e = form.querySelector('.ewf__err[data-for="' + n + '"]'); if (e) e.textContent = m || ""; }
  function validate() {
    var ok = true;
    fields.forEach(function (n) { setErr(n, ""); });
    if (!val("name")) { setErr("name", "Required"); ok = false; }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val("email"))) { setErr("email", "Enter a valid email"); ok = false; }
    if (!val("orderRef")) { setErr("orderRef", "Required"); ok = false; }
    if (!val("countryCode")) { setErr("countryCode", "Select your country"); ok = false; }
    if (!val("items")) { setErr("items", "Required"); ok = false; }
    return ok;
  }
  root.querySelector(".ewf__next").addEventListener("click", function () {
    if (!validate()) return;
    var dl = step2.querySelector(".ewf__review"); dl.innerHTML = "";
    fields.forEach(function (n) {
      var dt = document.createElement("dt"); dt.textContent = labels[n];
      var dd = document.createElement("dd"); dd.textContent = val(n);
      dl.appendChild(dt); dl.appendChild(dd);
    });
    step1.hidden = true; step2.hidden = false;
  });
  root.querySelector(".ewf__back").addEventListener("click", function () { step2.hidden = true; step1.hidden = false; });
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    if (!validate()) { step2.hidden = true; step1.hidden = false; return; }
    var hp = form.elements["ewf_hp"]; // honeypot; non-semantic name so browsers don't autofill it
    var payload = { elapsedMs: Date.now() - startedAt, ewf_hp: hp ? hp.value : "" };
    fields.forEach(function (n) { payload[n] = val(n); });
    var btn = root.querySelector(".ewf__submit"); btn.disabled = true; btn.textContent = "Submitting…";
    fetch(endpoint, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, j: j }; }); })
      .then(function (res) {
        if (res.status === 200 && res.j.ok) {
          form.querySelectorAll(".ewf__step").forEach(function (s) { s.hidden = true; });
          done.hidden = false;
          done.innerHTML = "";
          var h = document.createElement("h3"); h.textContent = "Request received";
          var p = document.createElement("p"); p.textContent = "Your reference is " + res.j.reference + ". We've emailed you an acknowledgement.";
          done.appendChild(h); done.appendChild(p);
        } else if (res.status === 422 && res.j.errors) {
          step2.hidden = true; step1.hidden = false;
          Object.keys(res.j.errors).forEach(function (n) { setErr(n, res.j.errors[n]); });
          btn.disabled = false; btn.textContent = "Confirm & submit";
        } else {
          btn.disabled = false; btn.textContent = "Confirm & submit";
          alert("Sorry, something went wrong. Please try again or email info@phixclothing.com.");
        }
      })
      .catch(function () { btn.disabled = false; btn.textContent = "Confirm & submit"; alert("Network error. Please try again or email info@phixclothing.com."); });
  });
})();
